import React from 'react';

export const BrandStory = () => {
  return (
    <section id="story" className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/images/story-background.jpeg)' }}
      ></div>
      
      {/* Overlay for text readability */}
      <div className="absolute inset-0 bg-white/85"></div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-light tracking-tight text-stone-900 mb-6">
            Our Story
          </h2>
        </div>
        
        <div className="prose prose-lg prose-stone max-w-none space-y-8">
          <p className="text-xl text-stone-700 leading-relaxed font-light">
            At Bernard Fan Co., we believe the most important details are the ones you live with every day.
          </p>
          
          <p className="text-lg text-stone-600 leading-relaxed">
            Our brand was founded on a simple idea: that functional objects should be as thoughtfully designed as the spaces they inhabit. In a world of disposable, mass-produced fixtures, we set out to offer something different — fans that are quietly powerful, beautifully crafted, and designed to endure.
          </p>
          
          <p className="text-lg text-stone-600 leading-relaxed">
            Our brand is known for mastery of materials, engineering precision, and design heritage. Each fan is chosen not only for performance, but for its ability to elevate a room — visually, acoustically, and experientially.
          </p>
          
          <p className="text-lg text-stone-600 leading-relaxed">
            Bernard Fan Co. exists at the intersection of form and function. Our fans are engineered for whisper-quiet airflow and long-term reliability, while remaining understated enough to complement refined interiors rather than compete with them. The result is a collection that feels intentional, timeless, and effortlessly luxurious.
          </p>
          
          <p className="text-lg text-stone-600 leading-relaxed">
            We work closely with homeowners, interior designers, architects, and hospitality professionals who understand that true luxury is never loud — it is felt. It's in the balance of proportion, the quality of materials, and the confidence of restraint.
          </p>
          
          <div className="text-center space-y-4 pt-8">
            <p className="text-2xl text-stone-900 font-light italic">
              For us, a fan is not an afterthought.
            </p>
            <p className="text-2xl text-stone-900 font-light italic">
              It is a finishing touch.
            </p>
            <p className="text-2xl text-stone-900 font-light italic">
              A design decision.
            </p>
            <p className="text-2xl text-stone-900 font-light italic">
              A standard.
            </p>
          </div>
          
          <p className="text-xl text-stone-900 text-center pt-8 tracking-wider">
            Welcome to Bernard Fan Co.
          </p>
        </div>
      </div>
    </section>
  );
};